import { c as createSurface } from './createSurface-c7340571.js';

const SurfaceDark = Object.assign(createSurface('dark'), {
  displayName: 'SurfaceDark'
});
const SurfaceDarkInfo = Object.assign(createSurface('blue'), {
  displayName: 'SurfaceDarkInfo'
});
const SurfaceLight = Object.assign(createSurface('light'), {
  displayName: 'SurfaceLight'
});

export { SurfaceDarkInfo as S, SurfaceDark as a, SurfaceLight as b };
//# sourceMappingURL=index-c3bd388c.js.map
